import * as angular from "angular";
import * as _ from "lodash";

angular
  .module('bringoz.admin.routes')
  .config(SiteMarketConfig);

function SiteMarketConfig($stateProvider) {

  $stateProvider
    .state('siteMarket', {
      parent: 'bringoz.site',
      url: '/market?:selectedId&:tab',
      template: '<site-market flex></site-market>',
      controller: function (triBreadcrumbsService, site) {
        triBreadcrumbsService.reset();
        const breadcrumbs = triBreadcrumbsService.breadcrumbs;
        if (_.isEmpty(breadcrumbs.crumbs)) {
          triBreadcrumbsService.addCrumb({name: "Market", state: "siteMarket"});
          triBreadcrumbsService.addCrumb({name: "Dispatch"});
        }
      }
    });

}
